<template>
	<transition name="options">
		<div v-show="app.actives.options" class="options">
			<v-touch @tap="close_options()" class="options-bg"></v-touch>
			<div class="options-content">

				<div class="option-row">
					<div class="label">{{ texts[lang].language }}</div>
					<div class="values">
						<div class="switch">
							<v-touch class="switch-value" @tap="toggle_lang()" :class="{ active: lang == 'en' }">EN</v-touch>
							<v-touch class="switch-value" @tap="toggle_lang()" :class="{ active: lang == 'fr' }">FR</v-touch>
							<!-- <v-touch class="switch-value" @tap="set_lang('de')" :class="{ active: lang == 'de' }">DE</v-touch> -->
						</div>
					</div>
				</div>
				<div class="option-row">
					<div class="label">{{ texts[lang].sounds }}</div>
					<div class="values">
						<div class="switch">
							<v-touch @tap="toggle_sounds()" class="switch-value" :class="{ active: app.user.sounds }">ON</v-touch>
							<v-touch @tap="toggle_sounds()" class="switch-value" :class="{ active: !app.user.sounds }">OFF</v-touch>
						</div>
					</div>
				</div>
				<div class="option-row">
					<div class="label">{{ texts[lang].color }}</div>
					<div class="values">
						<div class="colors">
							<v-touch @tap="set_color('dark')" class="color dark" :class="{ active: app.user.color == 'dark' }"></v-touch>
							<v-touch @tap="set_color('green')" class="color green" :class="{ active: app.user.color == 'green' }"></v-touch>
							<v-touch @tap="set_color('brown')" class="color brown" :class="{ active: app.user.color == 'brown' }"></v-touch>
							<v-touch @tap="set_color('purple')" class="color purple" :class="{ active: app.user.color == 'purple' }"></v-touch>
						</div>
					</div>
				</div>
				
			</div>
		</div>
	</transition>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'Options',
	computed: Object.assign(mapGetters([ 'app', 'lang', 'texts' ]), {
		
	}),
	methods: {
		set_color: function(color) {
			sounds.play('tap')
			this.$store.commit('EDIT_USER', { color: color })
			this.$store.dispatch('save_data')
		},
		toggle_lang: function() {
			sounds.play('tap')
			var lang = 'fr'
			if (this.lang == 'fr') lang = 'en'
				
			this.$store.commit('EDIT_USER', { lang: lang })
			this.$store.dispatch('save_data')
		},
		toggle_sounds: function() {
			sounds.play('tap')
			this.$store.dispatch('set_sounds', { sounds: !this.app.user.sounds })
			this.$store.dispatch('save_data')
		},
		close_options: function() {
			this.$store.dispatch('set_options_visible', { visible: false })
		}
	}
}
</script>

<style lang="stylus">
@import '../assets/css/app'


.options-enter-active, .options-leave-active
	transition 0.25s easeOutQuart
	.options-bg
		transition 0.25s easeOutQuart
	.options-content
		transition 0.25s easeOutQuart
		
.options-enter
	.options-bg
		opacity 0
	.options-content
		opacity 0
		transform translate3D(0, 24px, 0)

.options-leave-to
	opacity 0


.options
	position absolute
	left 0
	top 0
	right 0
	bottom 0
	.options-bg
		position absolute
		left 0
		top 0
		right 0
		bottom 0
		background alpha(dark, 75%)
	.options-content
		position absolute
		top 56px
		right 4px
		width 300px
		padding 8px 16px
		background light
		border-radius 8px
		&:before
			content ''
			position absolute
			right 16px
			top -8px
			width 0
			height 0
			border-style solid
			border-width 0 8px 8px 8px
			border-color transparent transparent light transparent
		.option-row
			height 64px
			line-height 32px
			padding 16px 0
			border-radius 4px
			border-bottom 1px dotted #ddd
			&:last-child
				margin-bottom 0
				border-bottom none
			.label
				float left
				padding-left 8px
			.values
				float right
				.switch
					.switch-value
						float left
						width 40px
						// padding 0 8px
						text-align center
						background lighten(#000, 90%)
						color alpha(#000, 50%)
						text-transform lowercase
						&:first-child
							border-top-left-radius 4px
							border-bottom-left-radius 4px
						&:last-child
							border-top-right-radius 4px
							border-bottom-right-radius 4px
						&.active
							background green
							color #fff
				.colors
					.color
						float left
						margin 0 0 0 8px
						width 32px
						height 32px
						border-radius 100%
						background dark
						&.green
							background-color app_green
						&.brown
							background-color app_brown
						&.purple
							background-color app_purple
						&.active
							opacity 1
							box-shadow inset 0 0 0 2px green, 0 0 0 2px green

</style>



// WEBPACK FOOTER //
// src/components/Options.vue